// -------------------- IMPORTS (You will update paths later) --------------------

// Hair Care
import RootInProduct from "../assets/images/allproducts/rootIn.jpg";
import RootInlogo from "../assets/images/allproducts/logos/Root-In.png";

import CeratinaProduct from "../assets/images/allproducts/Ceratina.jpg";
import Ceratinalogo from "../assets/images/allproducts/logos/ceratina.png";

import RootIn25Product from "../assets/images/allproducts/rootin2-5.jpg";
import RootIn25logo from "../assets/images/allproducts/logos/Root-In-2.5.png";

import RootIn1Product from "../assets/images/allproducts/rootin-1.25.jpeg";
import RootIn1logo from "../assets/images/allproducts/logos/Root-In-2.5.png";

import RootInFProduct from "../assets/images/allproducts/rootIn-F.jpg";
import RootInFlogo from "../assets/images/allproducts/logos/Root-In-F.png";


// Skin Care - Photoprotection
import BioUV32Product from "../assets/images/allproducts/Biouv-32.jpg";
import BioUV32logo from "../assets/images/allproducts/logos/BioUv-32.png";



import BioUV50Product from "../assets/images/allproducts/biouv50.jpg";
import BioUV50logo from "../assets/images/allproducts/logos/BioUv-50.png";

import BioUV50SprayProduct from "../assets/images/allproducts/Bio-uv-Sprey.jpg";
import BioUV50Spraylogo from "../assets/images/allproducts/logos/BioUV-50-Spray-1.png";



import BioUVFluid50Product from "../assets/images/allproducts/BiouvFluidspf50.jpg";
import BioUVFluid50logo from "../assets/images/allproducts/logos/BioUv-50.png";

import BioUVMineral50Product from "../assets/images/allproducts/Biouv-mineral.jpg";
import BioUVMineral50logo from "../assets/images/allproducts/logos/BioUv-50.png";


// Skin Care - Pigmentation


import MelaAct20Product from "../assets/images/allproducts/MelaAct2.png";
import MelaAct20logo from "../assets/images/allproducts/logos/Mela-Act.png";


// Skin Care - Soothing
import HydewFaceProduct from "../assets/images/allproducts/Hydew-moisturiser.jpg";
import HydewFacelogo from "../assets/images/allproducts/logos/Hydew-M.png";

import HydewBodyProduct from "../assets/images/allproducts/hydew-body-lotion.jpg";
import HydewBodyLogo from "../assets/images/allproducts/logos/Hydew-Body.png";

import HydewPMProduct from "../assets/images/allproducts/hYDEW-PM.jpg";
import HydewPMlogo from "../assets/images/allproducts/logos/Hydew-M.png";

import CutamPalmProduct from "../assets/images/allproducts/Cutam.jpg";
import CutamPalmLogo from "../assets/images/allproducts/logos/Cutam_PS.png";

import AngelDewProduct from "../assets/images/allproducts/Angel-dew.jpg";
import AngelDewlogo from "../assets/images/allproducts/logos/Angel-Dew.png";


// Skin Care - Acne
import SebosalProduct from "../assets/images/New-Products/new/sebosal-FaceWash.jpeg";
import Sebosallogo from "../assets/images/allproducts/logos/Sebosal.png";

import Seblok5Product from "../assets/images/New-Products/new/seblock-5.jpeg";
import Seblok5logo from "../assets/images/allproducts/logos/Seblok.png";

import Seblok10Product from "../assets/images/New-Products/new/seblock-10.jpeg";
import Seblok10logo from "../assets/images/allproducts/logos/Seblok.png";

import Seblok20Product from "../assets/images/New-Products/new/seblock-20.jpeg";
import Seblok20logo from "../assets/images/allproducts/logos/Seblok.png";


// Skin Care - Photoaging
import AgeretProduct from "../assets/images/allproducts/ageret.jpg";
import Ageretlogo from "../assets/images/allproducts/logos/Ageret.png";

import AzeliteProduct from "../assets/images/allproducts/azelite3.jpg";
import Azelitelogo from "../assets/images/allproducts/logos/Azelite-Logo.png";

import NiaaSerumProduct from "../assets/images/allproducts/Niaa-serum.jpg";
import NiaaSerumlogo from "../assets/images/allproducts/logos/Niaa-Serum.png";


// Skin Care - Psoriasis
import SoraLiteProduct from "../assets/images/allproducts/Solarite2.png";
import SoraLitelogo from "../assets/images/allproducts/logos/Soralite.png";

import EstaarProduct from "../assets/images/allproducts/Estaar3.png";
import EstaarLogo from "../assets/images/allproducts/logos/eStar.png";

import PeskloProduct from "../assets/images/allproducts/plesko4.png";
import Pesklologo from "../assets/images/allproducts/logos/Pesklo.png";

import CueONProduct from "../assets/images/New-Products/new/CueON.jpeg";
import CueONlogo from "../assets/images/Product logo/cue-on-logo.png";

import TazdoneProduct from "../assets/images/New-Products/new/Tazdone.jpeg";
import Tazdonelogo from "../assets/images/Product logo/tazdone-logo.png";


// Skin Care - Anti-Fungal
import ItzBio65Product from "../assets/images/allproducts/ItzBio65.png";
import ItzBio65logo from "../assets/images/allproducts/logos/ITZBIO65mg_logo.png";

import ItzBio130Product from "../assets/images/allproducts/ItzBio130.png";
import ItzBio130logo from "../assets/images/allproducts/logos/ITZBIO130mg_logo.png";


// Skin Care - Immunity
import CuMaxProduct from "../assets/images/allproducts/Cumax.jpg";
import CuMaxlogo from "../assets/images/allproducts/logos/CuMax.png";


// Skin Care - Anti-Allergic
import LongyProduct from "../assets/images/allproducts/Longy.png";
import Longylogo from "../assets/images/allproducts/logos/lONGY.png";


// Skin Care - Eczema
import ImulimusProduct from "../assets/images/allproducts/Imulimas.jpg";
import Imulimuslogo from "../assets/images/allproducts/logos/Imulimus.png";


// Medical Engineering
import MesoJetProduct from "../assets/images/allproducts/Mesojet.png";
import MesoJetlogo from "../assets/images/allproducts/logos/Mesojet-logo.png";

import UM150AProduct from "../assets/images/allproducts/UM150A.png";
import UM150Alogo from "../assets/images/allproducts/logos/UM-150-A-Product-Logo.png";


// Premium
// import MariniSkinProduct from "../assets/images/allproducts/MariniProducts/marini.png";
// import MariniSkinLogo from "../assets/images/allproducts/logos/MSS-Logo-lockup1-color.png";



// -------------------- MAIN PRODUCT LIST --------------------
const allProductsData = [
  // Photoprotection
  { id: 1, name: "BioUV 32", category: "Skin Care", applicationArea: "Face", quantity: "50gm", subCategory: "Photoprotection", logo: BioUV32logo, image: BioUV32Product, link: "/product/SkinCare/BioUV32" },
  { id: 3, name: "BioUV 50", category: "Skin Care", applicationArea: "Face", quantity: "50gm", subCategory: "Photoprotection", logo: BioUV50logo, image: BioUV50Product, link: "/product/SkinCare/BioUV50" },
  { id: 4, name: "BioUV Spray", category: "Skin Care", applicationArea: "Face, Body, Hair", quantity: "100ml", subCategory: "Photoprotection", logo: BioUV50Spraylogo, image: BioUV50SprayProduct, link: "/product/SkinCare/BioUV50Spray" },
  { id: 6, name: "BioUV Fluid", category: "Skin Care", applicationArea: "Face", quantity: "50gm", subCategory: "Photoprotection", logo: BioUVFluid50logo, image: BioUVFluid50Product, link: "/product/SkinCare/BioUVFluid" },
  { id: 7, name: "BioUV Mineral", category: "Skin Care", applicationArea: "Face", quantity: "50gm", subCategory: "Photoprotection", logo: BioUVMineral50logo, image: BioUVMineral50Product, link: "/product/SkinCare/BioUVMineral" },

  // Pigmentation

  { id: 9, name: "MelaAct 2.0", category: "Skin Care", applicationArea: "Face", quantity: "15gm", subCategory: "Pigmentation", logo: MelaAct20logo, image: MelaAct20Product, link: "/product/SkinCare/Melaact2" },

  // Skin Soothing
  { id: 10, name: "Hydew Face", category: "Skin Care", applicationArea: "Face", quantity: "50ml", subCategory: "Skin Soothing", logo: HydewFacelogo, image: HydewFaceProduct, link: "/product/SkinCare/Hydew-Face" },
  { id: 11, name: "Hydew Body Lotion", category: "Skin Care", applicationArea: "Body", quantity: "150ml", subCategory: "Skin Soothing", logo: HydewBodyLogo, image: HydewBodyProduct, link: "/product/SkinCare/hydewbodylotion" },
  { id: 12, name: "Hydew PM", category: "Skin Care", applicationArea: "Face", quantity: "80gm", subCategory: "Skin Soothing", logo: HydewPMlogo, image: HydewPMProduct, link: "/product/SkinCare/HYDewPM" },
  { id: 13, name: "Cutam palm & Sole", category: "Skin Care", applicationArea: "Palm and Sole", quantity: "100gm", subCategory: "Skin Soothing", logo: CutamPalmLogo, image: CutamPalmProduct, link: "/product/SkinCare/cutam" },
  { id: 14, name: "Angel Dew", category: "Skin Care", applicationArea: "Body", quantity: "100ml", subCategory: "Skin Soothing", logo: AngelDewlogo, image: AngelDewProduct, link: "/product/SkinCare/angeldew" },

  // Acne
  { id: 15, name: "Sebosal", category: "Skin Care", applicationArea: "Face", quantity: "150ml", subCategory: "Acne", logo: Sebosallogo, image: SebosalProduct, link: "/product/SkinCare/Sebosal" },
  { id: 16, name: "Seblok – 5mg", category: "Skin Care", applicationArea: "Oral", quantity: "10 capsules per strip", subCategory: "Acne", logo: Seblok5logo, image: Seblok5Product, link: "/product/SkinCare/Seblok5" },
  { id: 17, name: "Seblok – 10mg", category: "Skin Care", applicationArea: "Oral", quantity: "10 capsules per strip", subCategory: "Acne", logo: Seblok10logo, image: Seblok10Product, link: "/product/SkinCare/Seblok10" },
  { id: 18, name: "Seblok – 20mg", category: "Skin Care", applicationArea: "Oral", quantity: "10 capsules per strip", subCategory: "Acne", logo: Seblok20logo, image: Seblok20Product, link: "/product/SkinCare/Seblok20" },

  // Photoaging
  { id: 19, name: "Ageret", category: "Skin Care", subCategory: "Photoaging", applicationArea: "Face", quantity: "20 ml", logo: Ageretlogo, image: AgeretProduct, link: "/product/SkinCare/ageret" },
  { id: 20, name: "Azelite", category: "Skin Care", applicationArea: "Face", quantity: "30gm", subCategory: "Photoaging", logo: Azelitelogo, image: AzeliteProduct, link: "/product/SkinCare/azelite" },
  { id: 21, name: "Niaa Serum", category: "Skin Care", applicationArea: "Face", quantity: "30ml", subCategory: "Photoaging", logo: NiaaSerumlogo, image: NiaaSerumProduct, link: "/product/SkinCare/niaa-serum" },

  // Psoriasis
  { id: 22, name: "SoraLite", category: "Skin Care", applicationArea: "Affected Skin", quantity: "30ml", subCategory: "Psoriasis", logo: SoraLitelogo, image: SoraLiteProduct, link: "/product/SkinCare/SoraLite" },
  { id: 23, name: "eStaar solution", category: "Skin Care", applicationArea: "Scalp", quantity: "60ml", subCategory: "Psoriasis", logo: EstaarLogo, image: EstaarProduct, link: "/product/SkinCare/eStaar" },
  { id: 24, name: "Pesklo", category: "Skin Care", applicationArea: "Diseased Area", quantity: "30gm", subCategory: "Psoriasis", logo: Pesklologo, image: PeskloProduct, link: "/product/SkinCare/Pesklo" },
  { id: 36, name: "Cue-ON", category: "Skin Care", applicationArea: "Oral", quantity: "10 capsules per strip", subCategory: "Psoriasis", logo: CueONlogo, image: CueONProduct, link: "/product/SkinCare/CueON" },
  { id: 37, name: "Tazdone", category: "Skin Care", applicationArea: "Face", quantity: "20g", subCategory: "Psoriasis", logo: Tazdonelogo, image: TazdoneProduct, link: "/product/SkinCare/Tazdone" },

  // Anti-Fungal
  { id: 25, name: "ItzBio SB – 65 mg", category: "Skin Care", applicationArea: "Oral", quantity: "10 capsules per strip", subCategory: "Anti-Fungal", logo: ItzBio65logo, image: ItzBio65Product, link: "/product/SkinCare/ItzBio65" },
  { id: 26, name: "ItzBio SB – 130 mg", category: "Skin Care", applicationArea: "Oral", quantity: "10 capsules per strip", subCategory: "Anti-Fungal", logo: ItzBio130logo, image: ItzBio130Product, link: "/product/SkinCare/ItzBio130" },

  // Immunity-Booster
  { id: 27, name: "CuMax", category: "Skin Care", applicationArea: "Oral", quantity: "10 capsules per strip", subCategory: "Immunity-Booster", logo: CuMaxlogo, image: CuMaxProduct, link: "/product/SkinCare/Cumax" },

  // Anti-Allergic
  { id: 28, name: "Longy", category: "Skin Care", applicationArea: "Oral", quantity: "10 capsules per strip", subCategory: "Anti-Allergic", logo: Longylogo, image: LongyProduct, link: "/product/SkinCare/Longy" },

  // Eczema
  { id: 29, name: "Imulimus", category: "Skin Care", applicationArea: "Affected Skin", quantity: "30g", subCategory: "Eczema", logo: Imulimuslogo, image: ImulimusProduct, link: "/product/SkinCare/Imulimus" },

  // Hair Care
  { id: 30, name: "Ceratina", category: "Hair Care", applicationArea: "Oral", quantity: "10x3 capsules", subCategory: "Hair Care", logo: Ceratinalogo, image: CeratinaProduct, link: "/product/HairCare/Ceratina" },
  { id: 31, name: "Root In", category: "Hair Care", applicationArea: "Scalp", quantity: "60ml", subCategory: "Hair Care", logo: RootInlogo, image: RootInProduct, link: "/product/HairCare/rootin" },
  { id: 32, name: "Root In 2.5", category: "Hair Care", applicationArea: "Oral", quantity: "10x10 tablets", subCategory: "Hair Care", logo: RootIn25logo, image: RootIn25Product, link: "/product/HairCare/rootin2-5" },
  { id: 34, name: "Root In 1.25", category: "Hair Care", applicationArea: "Oral", quantity: "10x10 tablets", subCategory: "Hair Care", logo: RootIn25logo, image: RootIn1Product, link: "/product/HairCare/rootin1-25" },
  { id: 33, name: "Root In F", category: "Hair Care", applicationArea: "Scalp", quantity: "60ml", subCategory: "Hair Care", logo: RootInFlogo, image: RootInFProduct, link: "/product/HairCare/rootinf" },

  // Medical Engineering
  { id: 34, name: "Mesojet", category: "Medical Engineering", subCategory: "Medical Engineering", logo: MesoJetlogo, image: MesoJetProduct, link: "/product/Medical-Engineering/Mesojet" },
  { id: 35, name: "UM150A", category: "Medical Engineering", subCategory: "Medical Engineering", logo: UM150Alogo, image: UM150AProduct, link: "/product/Medical-Engineering/UM150A" },

];

export default allProductsData;


